<template>
    <div class="p-2 pl-4 m-0 b-overlay-wrap position-relative d-flex flex-column h-100 w-100">
        <b-container fluid class="m-0 p-0 b-overlay-wrap position-relative h-100" v-if="form.Sections[0].Fields">
            <FactorsEntering :FactorList="form.Sections[0].Fields"
                             :Variant="Variant ? Variant : 'secondary'"
                             :NodeId="NodeId"
                             :Action="Action" />
        </b-container>
    </div>
</template>


<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    import FactorsEntering from "@/components/commons/FactorsEntering.vue";
    import { BaseObjectForm } from "./BaseObjectForm";

    /** Composant  */
    @Component({
        components: {
            FactorsEntering
        }
    })
    export default class Factors extends BaseObjectForm {
    }
</script>

<style scoped>

</style>